import { render, staticRenderFns } from "./Inhalte.vue?vue&type=template&id=59155439"
import script from "./Inhalte.vue?vue&type=script&lang=js"
export * from "./Inhalte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports